class InvalidChargeTagIdException extends Error {
  constructor(message) {
    super(message);
    this.name = 'InvalidChargeTagIdException';
  }
}

export default InvalidChargeTagIdException;
